const Menus = [
    {
        id: 1,
        title: '新闻资讯',
        goto: { path: '/news' },
        class: 'is-open',
        isLoad: false,
        childs: [
            { id: '1', title: '政策', goto: { path: '/news', query: { cid: 1 } }, class: ''},
            { id: '2', title: '标准发布信息', goto: { path: '/news', query: { cid: 2 } }, class: '', },
            { id: '3', title: '行业资讯', goto: { path: '/news', query: { cid: 3 } }, class: 'is-sel', },
            { id: '4', title: '专利', goto: { path: '/news', query: { cid: 4 } }, class: '', },
            { id: '5', title: '学术文章', goto: { path: '/news', query: { cid: 5 } }, class: '', },
            { id: '6', title: '杂志转载', goto: { path: '/news', query: { cid: 6 } }, class: '', },
            { id: '7', title: '企业广告', goto: { path: '/news', query: { cid: 7 } }, class: '', },
        ]
    }, {
        id: 2,
        title: '讨论区',
        goto: { path: '/community' },
        class: '',
        isLoad: false,
        childs: [
            { id: '1', title: '讨论区1', goto: { path: '/community', query: { cid: 1 } }, class: '', },
            { id: '2', title: '讨论区2', goto: { path: '/community', query: { cid: 2 } }, class: '', },
            { id: '3', title: '讨论区3', goto: { path: '/community', query: { cid: 3 } }, class: '', },
            { id: '4', title: '讨论区4', goto: { path: '/community', query: { cid: 4 } }, class: '', },
        ]
    }, {
        id: 3,
        title: '信息发布',
        goto: { path: '/slist' },
        class: '',
        isLoad: false,
        childs: [
            { id: '1', title: '招聘信息', goto: { path: '/slist', query: { cid: 1 } }, class: '', },
            { id: '2', title: '求购信息', goto: { path: '/slist', query: { cid: 2 } }, class: '', },
            { id: '3', title: '项目合作', goto: { path: '/slist', query: { cid: 3 } }, class: '', },
            { id: '4', title: '寻求招标', goto: { path: '/slist', query: { cid: 4 } }, class: '', },
        ]
    }
]

export default Menus